import {CREDIT_CALC_ID} from '@/core/constants/common';
/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
*/
const promoRefinanceSlide = {
    slideImg: {
        src: 'profit-propositions/promo/promo4.jpg',
        alt: 'Отдайте кредит в хорошие руки',
    },
    slideTitle: {
        title: 'Отдайте кредит <br/> в хорошие руки',
    },
    slideValue: {
        value: 'Рефинансирование кредитов',
    },
    slideLink: '/for-individuals/refinancing',
};

/**
 * core/models/pages/for-individuals/cards/CardFeaturesModel.js
*/
const promoDiscountsSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/card-features/offer2.png',
        alt: 'Промо-акция банка Центр-инвест',
    },
    slideTitle: {
        title: 'Промо-акция банка &laquo;Центр-инвест&raquo;',
    },
    slideLink: 'http://promo.centrinvest.ru/',
};

/**
 * core/models/pages/for-individuals/cards/CardFeaturesModel.js
*/
const helloWorldSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/card-features/offer3.webp',
        alt: 'Привет Мир',
    },
    slideTitle: {
        title: 'Привет &laquo;Мир&raquo;',
    },
    slideValue: {
        value: `
            Платите картой &laquo;Мир&raquo;&nbsp;&mdash; получайте
            специальные предложения и&nbsp;скидки.
        `,
    },
    slideLink: 'https://privetmir.ru/',
};

/**
 * core/models/pages/home-page/cards/ProfitPropositionsModel.js
*/
const pensionSlide = {
    slideImg: {
        src: 'profit-propositions/popular/advanced.webp',
        alt: 'Пенсионная карта',
    },
    slideTitle: {
        title: 'Пенсионная карта',
    },
    slideValue: {
        value: `
            &#x2022; Бесплатное обслуживание
            <br>
            &#x2022; До&nbsp;16&nbsp;% на&nbsp;остаток по&nbsp;счету
        `,
    },
    slideLink: '/for-individuals/cards/debet-cards/pens?form-type=FormNewCard&step-type=MainStep',
    target: '_self',
};

/**
 * core/models/pages/for-individuals/cards/CardFeaturesModel.js
*/
const abroadTransfersSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/card-features/transfers.webp',
        alt: 'Переводы за границу',
    },
    slideTitle: {
        title: 'Переводы <br/>за&nbsp;границу',
    },
    slideValue: {
        value: 'Трансграничные переводы<br/>с&nbsp;карт&nbsp;&laquo;Центр-инвест&raquo;',
    },
    slideLink: '/for-individuals/cards/card-features#transfers',
    target: '_self',
};

/**
 * core/models/pages/for-individuals/cards/CardFeaturesModel.js
*/
const virtualCardSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/card-features/offer4.jpg',
        alt: 'Виртуальная карта',
    },
    slideTitle: {
        title: 'Виртуальная карта',
    },
    slideLink: '/for-individuals/mobile-bank',
};

/**
 * core/models/pages/for-individuals/cards/CardFeaturesModel.js
*/
const internetBankServiceSlide = {
    slideImg: {
        src: 'pages/for-individuals/cards/card-features/offer5.webp',
        alt: 'Современный и удобный способ управления Вашими средствами',
    },
    slideTitle: {
        title: 'Интернет банк',
    },
    slideValue: {
        value: `
            Современный и&nbsp;удобный способ управления Вашими средствами на&nbsp;счете
            банковской карты через Интернет.
        `,
    },
    slideLink: '/for-individuals/internet-bank-service',
};

/**
 * core/models/pages/home-page/HomePageModel.js
 * core/models/pages/business-page/SelfemployedModel.js
*/
const mobileBankServiceSlide = {
    slideImg: {
        src: 'useful-services/services1.png',
        alt: 'Управляйте финансами в одно касание',
    },
    slideTitle: {
        title: 'Мобильный банк',
    },
    slideValue: {
        value: 'Управляйте финансами в&nbsp;одно&nbsp;касание',
    },
    slideLink: '/for-individuals/mobile-bank',
};

/**
 * core/models/pages/home-page/HomePageModel.js
 * core/models/pages/business-page/SelfemployedModel.js
*/
const finEducationServiceSlide = {
    slideImg: {
        src: 'pages/business/selfemployed/services2.png',
        alt: 'Центр финансовой грамотности',
    },
    slideTitle: {
        title: 'Центр финансовой грамотности',
    },
    slideValue: {
        value: '<nobr>Социально-образовательный</nobr> проект банка <nobr>&laquo;Центр-инвест&raquo;</nobr>',
    },
    slideLink: 'https://xn----7sbbzgbvlb6b9j.xn--p1ai/',
};

/**
 * core/models/pages/home-page/HomePageModel.js
 * core/models/pages/business-page/BusinessModel.js
*/
const onlineServiceSlide = {
    slideImg: {
        src: 'components/business-page/services3.png',
        alt: 'Онлайн-сервисы',
    },
    slideTitle: {
        title: 'Онлайн-сервисы',
    },
    slideValue: {
        value: `
            Здесь вы&nbsp;можете подать заявку на&nbsp;кредит, заказать справку
            и&nbsp;другие&nbsp;услуги в&nbsp;<nobr>онлайн-режиме</nobr>
        `,
    },
    slideLink: '/for-individuals/online-applications',
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const clientBankServiceSlide = {
    slideImg: {
        src: 'components/business-page/services1.png',
        alt: 'Управляйте финансами в одно касание',
    },
    slideTitle: {
        title: 'Клиент-банк',
    },
    slideValue: {
        value: 'Управляйте финансами в&nbsp;одно касание',
    },
    slideLink: '/business/client-bank',
};

/*
    /core/models/pages/home-page/ProfitPropositionsModel.js
*/
export const indivCreditHolidaysSlide = {
    slideImg: {
        src: 'pages/for-individuals/repayment-credits/offer.jpg',
        alt: 'Кредитные каникулы для частных лиц',
    },
    slideTitle: {
        title: 'Кредитные каникулы для частных лиц',
    },
    slideLink: '/for-individuals/crediting/repayment-credits',
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const acceleratorServiceSlide = {
    slideImg: {
        src: 'pages/esg/accelerator.png',
        alt: 'Акселератор банка Центр-инвест',
    },
    slideTitle: {
        title: 'Акселератор',
    },
    slideValue: {
        value: 'Помощь в старте и развитии вашего бизнеса',
    },
    slideLink: 'https://acc.centrinvest.ru/',
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
*/
const acceleratorSzServiceSlide = {
    slideImg: {
        src: 'pages/business/selfemployed/services3.png',
        alt: 'Акселератор для самозанятых',
    },
    slideTitle: {
        title: 'Акселератор для самозанятых',
    },
    slideValue: {
        value: 'Пройди бесплатное обучение и&nbsp;сделай свой бизнес успешнее вместе с&nbsp;опытной командой.',
    },
    slideLink: 'https://acc.centrinvest.ru/sz',
};

const greenVectorServiceSlide = {
    slideImg: {
        src: 'pages/esg/green-vector.png',
        alt: 'Зеленый вектор',
    },
    slideTitle: {
        title: 'Журнал<br/>об&nbsp;экологичности и&nbsp;осознанности',
    },
    slideValue: {
        value: 'Пишем о&nbsp;том, как заботиться о&nbsp;себе, природе, близких и&nbsp;окружающих.',
    },
    slideLink: 'https://greenvector.media/',
};

const esgRatingSlide = {
    slideImg: {
        src: 'pages/esg/lamp.png',
        alt: 'ESG-рейтинг',
    },
    slideTitle: {
        title: 'ESG-рейтинг',
    },
    slideValue: {
        value: 'Получите высший рейтинг и доступ к льготным условиям',
    },
    slideLink: '/esg/esg-rating',
};

const centrPreparingSlide = {
    slideImg: {
        src: 'pages/esg/centr.jpg',
        alt: 'Центр подготовки кадров',
    },
    slideTitle: {
        title: 'Центр подготовки кадров',
    },
    slideValue: {
        value: 'От студенской практики до специалиста Банка',
    },
    slideLink: '/social-projects/career',
};

const cleverSlide = {
    slideImg: {
        src: 'pages/esg/clever.png',
        alt: 'Умная стипендия',
    },
    slideTitle: {
        title: 'Умная стипендия',
    },
    slideValue: {
        value: 'Финансовая поддержка молодых талантов',
    },
    slideLink: 'https://smartgrant.ru/',
};

const firstLoan = {
    slideImg: {
        src: 'slides/consumer-loan/first-credit-suggestion.webp',
        alt: 'Первый кредит',
    },
    slideTitle: {
        title: 'Первый кредит по&nbsp;сниженной ставке',
    },
    slideLink: `/for-individuals/crediting/consumer-loan#${CREDIT_CALC_ID}`,
    target: '_self',
};

export {
    promoRefinanceSlide,
    promoDiscountsSlide,
    helloWorldSlide,
    abroadTransfersSlide,
    virtualCardSlide,
    internetBankServiceSlide,
    mobileBankServiceSlide,
    finEducationServiceSlide,
    onlineServiceSlide,
    clientBankServiceSlide,
    acceleratorServiceSlide,
    acceleratorSzServiceSlide,
    greenVectorServiceSlide,
    esgRatingSlide,
    cleverSlide,
    centrPreparingSlide,
    pensionSlide,
    firstLoan,
};
